/**
 * EPIC 54 P2 — "you have an invitation waiting", for somebody who is already
 * working somewhere.
 *
 * The acceptance page no longer turns an existing member away, but that fix
 * is unreachable without this: nothing in the portal links to it, so a person
 * invited to a second company would have to guess the URL. An active
 * membership must not hide a pending invitation, and not linking to it hides
 * it just as effectively as redirecting away from it did.
 */

import { Alert, Button } from '@mui/material';
import { useTranslation } from '@rendimees24/i18n';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { listMyClientInvitations } from '../../../services/clientInvitations';

export function PendingInvitationBanner() {
  const { t } = useTranslation('client');
  const navigate = useNavigate();
  const location = useLocation();
  const [pending, setPending] = useState(0);

  useEffect(() => {
    let cancelled = false;
    void (async () => {
      try {
        const result = await listMyClientInvitations();
        if (!cancelled) setPending(result.pending);
      } catch {
        // A banner is not worth an error message of its own.
        if (!cancelled) setPending(0);
      }
    })();
    return () => { cancelled = true; };
  }, [location.pathname]);

  if (pending === 0 || location.pathname.startsWith('/client/invitation')) return null;

  return (
    <Alert
      severity="info"
      sx={{ mb: 2 }}
      action={
        <Button size="small" onClick={() => navigate('/client/invitation')}>
          {t('invitation.open')}
        </Button>
      }
    >
      {t('invitation.morePending', { count: pending })}
    </Alert>
  );
}
